export default __webpack_public_path__ + "static/media/fasting_right_window@3x.c91591b9.jpg";